module.exports = __webpack_public_path__ + "static/Canela-BlackItalic-1d26533e30e8fca6f50ce94d643ec544.otf";